import classNames from "classnames";
import style from "./dialog.module.scss";
import PropTypes from "prop-types";

const Dialog = ({ confirmFunction, heading, bodyText, buttonText, isOpen, setIsOpen }) => {
  return (
    <>
      {isOpen ? (
        <>
          <div className={style.overlay}></div>
          <div className={classNames("size-14", style.dialog)}>
            <div className="size-22">
              {heading}
            </div>
            <div>
              {bodyText}
            </div>
            <div className={style.line}></div>
            <div className={style.buttonSection}>
              <button className={style.closeButton} onClick={() => setIsOpen(false)}>
                Cancel
              </button>
              <button className={style.confirmButton} onClick={confirmFunction}>
                {buttonText}
              </button>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}

Dialog.propTypes = {
  confirmFunction: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default Dialog;